import * as React from 'react';
import type { SVGIconProps } from './Icon.types';

const UploadBucketIcon = React.forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        ref={forwardedRef}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <title>{props.title}</title>
        <path
          clipRule="evenodd"
          d="M4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19ZM13 9V16H11V9H6L12 3L18 9H13Z"
          fill={color}
          fillRule="evenodd"
        />
      </svg>
    );
  },
);

export default UploadBucketIcon;
